<template>
  <v-card height="100%">
    <v-card-title class="primary">
      <div class="white--text d-flex align-center">
        <v-icon color="white" class="mr-3">
          mdi-calendar-month
        </v-icon>
        Depositos calendarizados
      </div>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :loading-text="table.title"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100]
        }"
        :items-per-page="25"
        sort-by="updatedAt"
        @update:options="updateTable">
        <template v-slot:item.amount="{ item }">
          {{ item.amount | toFixNumber(2) | numberWithComma  | prefix('$') }}
        </template>
        <template v-slot:item.updatedAt="{ item }">
          {{ item.updatedAt | toDate() }}
        </template>
        <template v-slot:item.status="{ item }">
          {{ statusName(item.status) }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { isEqual } from 'lodash'
import Restaurant from '@/models/Restaurant'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const restaurantModel = new Restaurant()
    return {
      restaurantModel,
      table: {
        title: 'Cargando depositos...',
        loading: true,
        headers: [
          { text: 'Monto', value: 'amount', sortable: false },
          { text: 'Última actualización', value: 'updatedAt', sortable: false },
          { text: 'Estatus', value: 'status', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 25,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      }
    }
  },
  computed: {
    restaurant () {
      return this.$store.state.currentRestaurant.data
    }
  },
  async mounted () {
    await this.load()
  },
  methods: {
    statusName (status) {
      return {
        created: 'Pendiente',
        done: 'Pagada'
      }[status]
    },
    updateTable: async function (data) {
      const options = this.table.options
      if (!isEqual(options, data)) {
        await this.load({
          limit: data.itemsPerPage,
          skip: (data.itemsPerPage * (data.page - 1))
        })
      }
    },
    async load (params = null) {
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1))
      }
      this.table.loading = true
      try {
        const response = await this.$api.get(`/v1/restaurants/${this.restaurant._id}/balance/deposits`, params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    }
  }
}
</script>
